<template>
  <div>
    <user-search-form
      :menuName="menuName"
      :companyData="companyData"
      @onSearchClick="onSearchUserClick" />

    <user-list
      :menuName="menuName"
      :users="users"
      @onRemoveClick="onRemoveClick" />
  </div>
</template>

<script>
import modalEvent from '@/lib/modal-event'
import ajaxHandlerMixin from '@/mixins/ajax-handler'
import UserSearchForm from '@/components/admin/UserSearchForm'
import UserList from '@/components/admin/UserList'
import adminApi from '@/api/admin'
import appDataApi from '@/api/app-data'

const defaultSearchOptions = {
  statusCode: 1
}

export default {
  name: 'ManageUser',
  mixins: [ajaxHandlerMixin],
  components: {
    UserSearchForm,
    UserList
  },
  props: ['menuName'],
  data () {
    return {
      users: [],
      companyData: null,
      searchUserOptions: Object.assign({}, defaultSearchOptions)
    }
  },
  created () {
    this.fetchCompanyData()
    this.fetchUsers()
  },
  methods: {
    fetchCompanyData () {
      appDataApi.findCompanies().then(response => {
        this.companyData = response.data
      })
    },
    fetchUsers () {
      return adminApi.findUsers(this.searchUserOptions)
        .then(response => {
          this.users = response.data
        })
    },
    onSearchUserClick (options) {
      this.searchUserOptions = Object.assign({}, options, defaultSearchOptions)
      this.fetchUsers()
    },
    onRemoveClick (ids, isBatch) {
      adminApi.removeUsers(ids).then(response => {
        if (!response.data) {
          throw this.getOperationError()
        }
        return this.fetchUsers()
      }).then(() => {
        modalEvent.openToast('common.deleted')
      }).catch(this.handleAjaxError)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/ManageUser.vue